/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import {
  CreateCompanyListResponseData,
  CreateCompanyListResponseDataFromJSON,
  CreateCompanyListResponseDataFromJSONTyped,
  CreateCompanyListResponseDataToJSON
} from './CreateCompanyListResponseData'

/**
 *
 * @export
 * @interface AppendCompanyListResponse
 */
export interface AppendCompanyListResponse {
  /**
   *
   * @type {number}
   * @memberof AppendCompanyListResponse
   */
  status?: number
  /**
   *
   * @type {CreateCompanyListResponseData}
   * @memberof AppendCompanyListResponse
   */
  data?: CreateCompanyListResponseData
}

export function AppendCompanyListResponseFromJSON(json: any): AppendCompanyListResponse {
  return AppendCompanyListResponseFromJSONTyped(json, false)
}

export function AppendCompanyListResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): AppendCompanyListResponse {
  if (json === undefined || json === null) {
    return json
  }
  return {
    status: !exists(json, 'status') ? undefined : json['status'],
    data: !exists(json, 'data') ? undefined : CreateCompanyListResponseDataFromJSON(json['data'])
  }
}

export function AppendCompanyListResponseToJSON(value?: AppendCompanyListResponse | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    status: value.status,
    data: CreateCompanyListResponseDataToJSON(value.data)
  }
}
